import {
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowUpDown,
  Award,
  BarChart,
  Bed,
  BookOpen,
  Briefcase,
  CheckCircle,
  Clock,
  Code,
  Cpu,
  Database,
  Facebook,
  FileText,
  Globe,
  Heart,
  Home,
  Instagram,
  Laptop,
  LayoutGrid,
  Leaf,
  LineChart,
  Link,
  Linkedin,
  Loader,
  Lock,
  Mail,
  Megaphone,
  MessageSquare,
  Microscope,
  Monitor,
  MonitorSmartphone,
  MousePointerClick,
  Pencil,
  PhoneCall,
  PieChart,
  Plus,
  Rocket,
  Scan,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  Smartphone,
  Star,
  Stethoscope,
  Syringe,
  Target,
  ThumbsUp,
  Trash2,
  TrendingUp,
  Twitter,
  User,
  Users,
  Wifi,
  Youtube,
  Zap,
} from "lucide-react";

export const icons = [
  { value: "home", label: "Início / Home", icon: Home },
  { value: "leaf", label: "Meio Ambiente / Natureza", icon: Leaf },
  { value: "bed", label: "Cama / Hotelaria", icon: Bed },
  { value: "stethoscope", label: "Saúde / Medicina", icon: Stethoscope },
  { value: "microscope", label: "Ciência / Laboratório", icon: Microscope },
  { value: "scan", label: "Digitalização / Scan", icon: Scan },
  { value: "syringe", label: "Vacina / Injeção", icon: Syringe },
  { value: "alert-triangle", label: "Atenção / Cuidado", icon: AlertTriangle },
  // TI
  { value: "code", label: "Código", icon: Code },
  { value: "database", label: "Banco de Dados", icon: Database },
  { value: "server", label: "Servidor", icon: Server },
  { value: "laptop", label: "Laptop", icon: Laptop },
  { value: "monitor", label: "Monitor", icon: Monitor },
  { value: "smartphone", label: "Smartphone", icon: Smartphone },
  { value: "monitor-smartphone", label: "Responsivo", icon: MonitorSmartphone },
  { value: "cpu", label: "CPU / Hardware", icon: Cpu },
  { value: "layout", label: "Layout", icon: LayoutGrid },
  { value: "shield", label: "Segurança", icon: Shield },
  { value: "wifi", label: "Wi-Fi", icon: Wifi },
  { value: "lock", label: "Privacidade", icon: Lock },
  { value: "settings", label: "Configurações", icon: Settings },

  // Marketing
  { value: "megaphone", label: "Marketing", icon: Megaphone },
  { value: "bar-chart", label: "Gráfico de Barras", icon: BarChart },
  { value: "line-chart", label: "Gráfico de Linhas", icon: LineChart },
  { value: "pie-chart", label: "Gráfico de Pizza", icon: PieChart },
  { value: "globe", label: "Web / SEO", icon: Globe },
  { value: "mail", label: "E-mail Marketing", icon: Mail },
  { value: "message", label: "Mensagem", icon: MessageSquare },
  { value: "phone-call", label: "Contato", icon: PhoneCall },
  { value: "user", label: "Usuário", icon: User },
  { value: "users", label: "Equipe", icon: Users },
  { value: "link", label: "Link", icon: Link },
  { value: "share", label: "Compartilhar", icon: Share2 },
  { value: "target", label: "Alvo / Meta", icon: Target },
  { value: "rocket", label: "Lançamento", icon: Rocket },
  { value: "trending-up", label: "Tendência", icon: TrendingUp },
  { value: "activity", label: "Atividade", icon: Activity },
  { value: "thumbs-up", label: "Aprovação", icon: ThumbsUp },
  { value: "star", label: "Destaque", icon: Star },

  // Comuns / Interface
  { value: "alert", label: "Alerta", icon: AlertCircle },
  { value: "arrow-up-down", label: "Mover", icon: ArrowUpDown },
  { value: "plus", label: "Adicionar", icon: Plus },
  { value: "trash", label: "Excluir", icon: Trash2 },
  { value: "pencil", label: "Editar", icon: Pencil },
  { value: "file", label: "Documento", icon: FileText },
  { value: "book", label: "Documentação", icon: BookOpen },
  { value: "briefcase", label: "Portfólio / Trabalho", icon: Briefcase },
  { value: "check", label: "Concluído", icon: CheckCircle },
  { value: "zap", label: "Rápido / Energia", icon: Zap },
  { value: "mouse", label: "Clique", icon: MousePointerClick },
  { value: "loader", label: "Carregando", icon: Loader },
  { value: "search", label: "Buscar", icon: Search },

  { value: "award", label: "Prêmio", icon: Award },
  { value: "clock", label: "Rapidez", icon: Clock },
  { value: "heart", label: "Cuidado", icon: Heart},

  { value: "facebook", label: "Facebook", icon: Facebook },
  { value: "instagram", label: "Instagram", icon: Instagram },
  { value: "twitter", label: "Twitter/X", icon: Twitter },
  { value: "linkedin", label: "LinkedIn", icon: Linkedin },
  { value: "youtube", label: "YouTube", icon: Youtube},

]